import { usePaging } from 'hooks/usePaging';
import { useGetContactCustomersQuery } from 'services';
import { FindAllContactCustomersDto } from 'types/dto/contacts';
import { DEFAULT_PAGE_SIZE } from 'utils';
const pageSize = DEFAULT_PAGE_SIZE;
export function useContactCustomersPaging(params: Omit<FindAllContactCustomersDto, 'pageSize'>, enabled = true) {
  const { contactId, keyword } = params;
  const { pageIndex, changePage, resetPage } = usePaging(params);
  const {
    data: customersResponse,
    error,
    isFetching,
    isLoading
  } = useGetContactCustomersQuery(
    {
      pageIndex,
      pageSize,
      keyword,
      contactId
    },
    {
      refetchOnMountOrArgChange: true,
      skip: !enabled
    }
  );
  const handleChangePage = changePage;

  return {
    contactCustomers: customersResponse?.data.rows,
    count: customersResponse ? customersResponse.data.count : 0,
    isLoading: isFetching || isLoading,
    pageSize,
    pageIndex,
    handleChangePage,
    resetPage,
    error
  };
}
